module.exports = __webpack_public_path__ + "media/newstyle/images/slider-arrow-right-grey-8a37cc964333a0888a795d0d568c5542.svg";